import { styles } from "./CustomerTable.style";
import { orderBy } from "lodash";
import * as React from "react";

import {
    Table,
    TableBody,
    TableCell,
    TableRow,
    Typography,
    withStyles,
    WithStyles
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";

import { Customer } from "../../types/Customer";
import { Quotation } from "../../types/Quotation";
import { getProductTitle, getDate } from "../../helper/functions.helper";
import { last } from "lodash";
import TableHeadSortable from "../TableHeadSortable/TableHeadSortable";
import ActionHistoryItem from "../ActionHistoryItem/ActionHistoryItem";

import { maxBy, values } from "lodash";

interface CustomerTableProps {
    background?: string;
    customers: { [customerId: string]: Customer };
    push(path: string): void;
}
interface CustomerTableState {
    filter: string;
    order: "asc" | "desc";
}

const rows = [
    { id: "date", label: "Date" },
    { id: "client", label: "Client" },
    { id: "product", label: "Produit" },
    { id: "status", label: "Dernier Statut" }
];

class CustomerTable extends React.Component<CustomerTableProps & WithStyles<typeof styles>, CustomerTableState> {

    state: CustomerTableState = {
        order: "asc",
        filter: "date"
    };

    public render() {

        const { classes, customers } = this.props;
        const { order, filter } = this.state;

        const orderedCustomer: Customer[] = orderBy(
                customers,
                customer => {
                    // TODO: @bm - merge into customer data?
                    const lastQuotation = this.getLastQuotation(customer);
                    switch (filter) {
                        case "client":
                            return customer.lastname;
                        case "product":
                            return getProductTitle(lastQuotation.productName, lastQuotation.productVariantName);
                        case "status":
                            // TODO: @ab - finish sorting properly (with quotation status)
                            // return lastQuotation.lastUpdate;
                            return 1;
                        default:
                            return customer.creationDate;
                    }
                },
                [order]
            );

        return (
            <Table>

                <TableHeadSortable
                    order={order}
                    orderBy={filter}
                    rows={rows}
                    onRequestSort={(property: string) => this.handleRequestSort(property)}
                />

                <TableBody>
                    {orderedCustomer.length > 0 ? ( orderedCustomer.map(customer => {
                        const lastQuotation = this.getLastQuotation(customer);
                        return (
                            <TableRow className={classes.row} key={customer.id}>
                                <TableCell className={classes.cell}>
                                    <Typography>{getDate(lastQuotation.creationDate) || "-"}</Typography>
                                </TableCell>
                                <TableCell className={classes.cell}>
                                    <Typography>{customer.lastname} {customer.firstname}</Typography>
                                </TableCell>
                                <TableCell className={classes.cell}>
                                    <Typography>{getProductTitle(lastQuotation.productName, lastQuotation.productVariantName)}</Typography>
                                </TableCell>
                                <TableCell className={classes.cell}>
                                    <ActionHistoryItem actionHistory={last(lastQuotation.actionHistory)}/>
                                </TableCell>
                                <TableCell className={classes.cell}>
                                    <Typography className={classes.cellLink} onClick={() => this.props.push(`/customer/${customer.id}`)}>
                                        <VisibilityIcon className={classes.cellIcon}/> Voir la fiche
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        );
                    })
                    ) : (
                    <TableRow className={classes.row}>
                        <TableCell className={classes.cell}/>
                        <TableCell className={classes.cell}/>
                        <TableCell className={classes.cell}>
                            Vous n'avez pas encore de clients
                        </TableCell>
                        <TableCell className={classes.cell}/>
                        <TableCell className={classes.cell}/>
                    </TableRow>
                    )
                    }
                </TableBody>
            </Table>
        );
    }

    private handleRequestSort (property: string) {
        this.setState({
            order: (this.state.filter === property && this.state.order === "desc") ? "asc" : "desc",
            filter: property
        });
    }

    private getLastQuotation(customer: Customer): Quotation {
        return maxBy(values(customer.quotations), (q) => q.creationDate);
    }

}

export default withStyles(styles)(CustomerTable);


// WEBPACK FOOTER //
// ./src/components/CustomerTable/CustomerTable.tsx